import { sva } from "@stubhub/broadway-foundation/css";

export const continueBrowsingBannerRecipe = sva({
  slots: ["wrapper", "card", "textBlock", "meta", "thumb"],
  className: "continueBrowsingBanner",
  base: {
    wrapper: {
      paddingInline: "primitives.150",
      width: "full",
    },
    card: {
      display: "flex",
      alignItems: "center",
      columnGap: "primitives.200",
      paddingBlock: "primitives.200",
      paddingInline: "primitives.200",
      borderStartRadius: "primitives.200",
      borderEndRadius: "primitives.200",
      backgroundColor: "bg",
      boxShadow: "floating",
      textDecorationLine: "none",
      width: "full",
    },
    textBlock: {
      display: "flex",
      flexDirection: "column",
      rowGap: "primitives.100",
      flexGrow: "1",
      flexShrink: "1",
      flexBasis: "primitives.0",
      minWidth: "primitives.0",
    },
    meta: {
      display: "flex",
      alignItems: "center",
      columnGap: "primitives.50",
    },
    thumb: {
      flexGrow: "0",
      flexShrink: "0",
      width: "primitives.800",
      height: "primitives.800",
      objectFit: "cover",
      borderStartRadius: "primitives.200",
      borderEndRadius: "primitives.200",
      borderBlockStartWidth: "default",
      borderInlineEndWidth: "default",
      borderBlockEndWidth: "default",
      borderInlineStartWidth: "default",
      borderBlockStartStyle: "solid",
      borderInlineEndStyle: "solid",
      borderBlockEndStyle: "solid",
      borderInlineStartStyle: "solid",
      borderBlockStartColor: "bg",
      borderInlineEndColor: "bg",
      borderBlockEndColor: "bg",
      borderInlineStartColor: "bg",
    },
  },
});
